import { IncoTermsType } from '../graphql';

const incoTermDescriptions: { name: IncoTermsType; description: string }[] = [
  // Group 1 Incoterms: Apply to Any Mode of Transport
  { name: IncoTermsType.EXW, description: 'Ex Works' },
  { name: IncoTermsType.FCA, description: 'Free Carrier' },
  { name: IncoTermsType.CPT, description: 'Carriage Paid To' },
  { name: IncoTermsType.CIP, description: 'Carriage and Insurance Paid To' },
  { name: IncoTermsType.DAT, description: 'Delivered at Terminal' },
  { name: IncoTermsType.DAP, description: 'Delivered at Place' },
  { name: IncoTermsType.DDP, description: 'Delivered Duty Paid' },
  // Group 2 Incoterms: Apply to Sea and Inland Waterway Transport
  { name: IncoTermsType.FAS, description: 'Free Alongside Ship' },
  { name: IncoTermsType.FOB, description: 'Free on Board' },
  { name: IncoTermsType.CFR, description: 'Cost and Freight' },
  { name: IncoTermsType.CIF, description: 'Cost, Insurance, and Freight' },
];

export const incoTermValues = incoTermDescriptions.map((o) => o.name);

export const asIncotermValue = (s: string | null): IncoTermsType | null =>
  incoTermDescriptions.find((d) => d.name === s)?.name ?? null;

export default incoTermDescriptions;
